import React, { useState } from 'react';
import Select from 'react-select';

// Checkbox menu for a toolbar filter. Nothing ticked means every option.
export default function MultiCheckSelect({ value, onChange, options, allLabel, minWidth = 150 }) {
  const [input, setInput] = useState('');
  const selected = Array.isArray(value) ? value : [];
  const active = selected.length > 0;
  const choices = (options || []).map((name) => ({ value: name, label: name }));

  return (
    <div style={{ minWidth, width: minWidth }}>
      <Select
        value={selected}
        onChange={(next) => onChange(next || [])}
        inputValue={input}
        onInputChange={(val, action) => { if (action.action === 'input-change') setInput(val); }}
        options={choices}
        isMulti
        isSearchable
        isClearable
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        controlShouldRenderValue={false}
        maxMenuHeight={typeof window !== 'undefined' ? window.innerHeight - 140 : 800}
        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
        menuShouldScrollIntoView={false}
        placeholder={active ? `${selected.length} selected` : allLabel}
        noOptionsMessage={() => 'None'}
        formatOptionLabel={(option, { context }) => {
          if (context === 'value') return <span>{option.label}</span>;
          const checked = selected.some((item) => item.value === option.value);
          return (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <input type="checkbox" checked={checked} readOnly style={{ cursor: 'pointer', accentColor: '#3b82f6' }} />
              <span>{option.label}</span>
            </div>
          );
        }}
        styles={{
          control: (base) => ({
            ...base,
            minHeight: 30,
            borderRadius: 6,
            fontSize: 12,
            background: 'var(--surface, #fff)',
            borderColor: active ? '#3b82f6' : 'var(--border, #ddd)',
            boxShadow: 'none'
          }),
          valueContainer: (base) => ({ ...base, padding: '0 6px' }),
          indicatorsContainer: (base) => ({ ...base, height: 28 }),
          menu: (base) => ({ ...base, zIndex: 10000, background: 'var(--surface, #fff)' }),
          menuPortal: (base) => ({ ...base, zIndex: 10000 }),
          menuList: (base) => ({ ...base, maxHeight: 'calc(100vh - 140px)' }),
          option: (base, state) => ({
            ...base,
            background: state.isFocused ? 'var(--tab-bg, #f0f4ff)' : 'var(--surface, #fff)',
            color: 'var(--text-primary, #111)',
            cursor: 'pointer',
            padding: '4px 10px'
          }),
          placeholder: (base) => ({ ...base, color: active ? '#3b82f6' : 'var(--text-secondary, #6b7280)', fontSize: 12 })
        }}
      />
    </div>
  );
}
